import { useTranslation } from 'react-i18next'

export const underageScopeOptions = () => {
  const { t } = useTranslation()
  return {
  address: {
    title: t('consent_list.address', 'Address'),
    details: [
      t('consent_list.scope_address_view_underage', 'Can view your child\'s mailing address')
    ]
  },
  dob: {
    title: t('consent_list.date_of_birth', 'Date of Birth'),
    details: [
      t('consent_list.scope_dob_view_underage', 'Can view your child\'s date of birth')
    ]
  },
  'email': {
    title: t('consent_list.scope_email', 'Email Address'),
    details: [
      t('consent_list.scope_email_view_underage', 'Can view your child\'s email address, if they use their own email address'),
      t('consent_list.scope_email_send_underage', 'Can email your child with app updates')
    ]
  },
  'friends': {
    title: t('consent_list.scope_friends', 'Friends Management'),
    details: [
      t('consent_list.scope_friends_deny_underage', 'Can approve or deny friend requests to your child from other trainers'),
      t('consent_list.scope_friends_remove_underage', 'Can remove friends from your child\'s friends list'),
      t('consent_list.scope_friends_request_underage', 'Can initiate friend requests from your child to other trainers'),
      t('consent_list.scope_friends_view_underage', 'Can view a list of your child\'s friends')
    ]
  },
  'location': {
    title: t('consent_list.location', 'Location'),
    details: [
      t('consent_list.scope_location_view_underage', 'Can view the city and state your child lives in')
    ]
  },
  'name': {
    title: t('consent_list.name', 'Name'),
    details: [
      t('consent_list.scope_name_view_underage', 'Can view your child\'s full legal name')
    ]
  },
  'openid': {
    title: t('consent_list.scope_basic', 'Basic Account Information'),
    details: [
      t('consent_list.scope_basic_consent_parent_underage', 'Can view that your child is under the age of digital consent according to your child\'s Pokémon Trainer Club account')
    ]
  },
  'over16': {
    title: t('consent_list.scope_age', 'Age'),
    details: [
      t('consent_list.scope_age_view_underage', 'Can view the age bracket your child is in according to your Pokémon Trainer Club Account')
    ]
  },
  'phone_number': {
    title: t('consent_list.phone_number', 'Phone Number'),
    details: [
      t('consent_list.scope_phone_view_underage', 'Can view your child\'s phone number'),
      t('consent_list.scope_phone_send_underage', 'Can contact your child by phone for non-marketing purposes')
    ]
  },
  'screen_name': {
    title: t('consent_list.scope_screenname', 'Screen Name'),
    details: [
      t('consent_list.scope_screenname_view_underage', 'Can view your child\'s screen name'),
      t('consent_list.scope_screenname_display_underage', 'Can display your child\'s screen name to other trainers')
    ]
  },
  'username':{
    title: t('consent_list.username', 'Username'),
    details: [
      t('consent_list.scope_username_view_underage', 'Can view your child\'s username')
    ]
  },
  'state': {
    title: t('consent_list.scope_state', 'State'),
    details: [
      t('consent_list.scope_state_view_underage', 'Can view your child\'s state')
    ]
  }
}};


export const overageScopeOptions = () => {
  const { t } = useTranslation()
  return { 
  'address': {
    title: t('consent_list.address', 'Address'),
    details: [
      t('consent_list.scope_address_view_overage', 'Can view your mailing address')
    ]
  },
  'dob': {
    title: t('consent_list.date_of_birth', 'Date of Birth'),
    details: [
      t('consent_list.scope_dob_view_overage', 'Can view your date of birth')
    ]
  },
  'email': {
    title: t('consent_list.scope_email', 'Email Address'),
    details: [
      t('consent_list.scope_email_view_overage', 'Can view your email address'),
      t('consent_list.scope_email_send_overage', 'Can email you with app updates')
    ]
  },
  'friends': {
    title: t('consent_list.scope_friends', 'Friends Management'),
    details: [
      t('consent_list.scope_friends_deny_overage', 'Can approve or deny friend requests to you from other trainers'),
      t('consent_list.scope_friends_remove_overage', 'Can remove friends from your friends list'),
      t('consent_list.scope_friends_request_overage', 'Can initiate friend requests from you to other trainers'),
      t('consent_list.scope_friends_view_overage', 'Can view a list of your friends')
    ]
  },
  'location': {
    title: t('consent_list.location', 'Location'),
    details: [
      t('consent_list.scope_location_view_overage', 'Can view the city and state you live in')
    ]
  },
  'name': {
    title: t('consent_list.name', 'Name'),
    details: [
      t('consent_list.scope_name_view_overage', 'Can view your full legal name')
    ]
  },
  'openid': {
    title: t('consent_list.scope_basic', 'Basic Account Information'),
    details: [
      t('consent_list.scope_basic_consent_overage', 'Can view that you are over the age of digital consent according to your Pokémon Trainer Club account')
    ]
  },
  'over16': {
    title: t('consent_list.scope_age', 'Age'),
    details: [
      t('consent_list.scope_age_view_overage', 'Can view the age bracket you are in according to your Pokémon Trainer Club Account')
    ]
  },
  'phone_number': {
    title: t('consent_list.phone_number', 'Phone Number'),
    details: [
      t('consent_list.scope_phone_view_overage', 'Can view your phone number'),
      t('consent_list.scope_phone_send_overage', 'Can contact you by phone for non-marketing purposes')
    ]
  },
  'screen_name': {
    title: t('consent_list.scope_screenname', 'Screen Name'),
    details: [
      t('consent_list.scope_screenname_view_overage', 'Can view your screen name'),
      t('consent_list.scope_screenname_display_overage', 'Can display your screen name to other trainers')
    ]
  },
  'username':{
    title: t('consent_list.username', 'Username'),
    details: [
      t('consent_list.scope_username_view_overage', 'Can view your username')
    ]
  },
  'state': {
    title: t('consent_list.scope_state', 'State'),
    details: [
      t('consent_list.scope_state_view_overage', 'Can view your state')
    ]
  }
}};